/**
 * @generated SignedSource<<f3d335ae492aece071328bb1d0e330a1>>
 * This file was auto-generated by 🫗 typsy.
 * Command: `yarn typsy`
 *
 * @see https://go/typsy
 **/

export type InputMaybe<T> = T | null | undefined;
export type Exact<
  T extends {
    [key: string]: unknown;
  },
> = {
  [K in keyof T]: T[K];
};
/** All built-in and custom scalars, mapped to their actual values */
export interface Scalars {
  ID: {
    input: string;
    output: string;
  };
  String: {
    input: string;
    output: string;
  };
  Boolean: {
    input: boolean;
    output: boolean;
  };
  Int: {
    input: number;
    output: number;
  };
  Float: {
    input: number;
    output: number;
  };
  DateTime: {
    input: Date;
    output: Date;
  };
  /** Long type */
  Long: {
    input: number;
    output: number;
  };
  /** High level representation of a Number could be a float or an integer */
  Number: {
    input: number;
    output: number;
  };
}
export enum SitePermissionType {
  ANONYMOUS = "ANONYMOUS",
  APP = "APP",
  EXTERNAL = "EXTERNAL",
  INTERNAL = "INTERNAL",
  JSD = "JSD",
}
export type fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon =
  {
    __typename?: "Icon";
    isDefault: boolean | null;
    path: string;
  };
export type fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous =
  {
    __typename?: "Anonymous";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon | null;
  };
export type fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_KnownUser =
  {
    __typename?: "KnownUser";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon | null;
  };
export type fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_UnknownUser =
  {
    __typename?: "UnknownUser";
    accountId: string | null;
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon | null;
  };
export type fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_User =
  {
    __typename?: "User";
    displayName: string | null;
    permissionType: SitePermissionType | null;
    profilePicture: fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous_profilePicture_Icon | null;
  };
export type fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes =

    | fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_Anonymous
    | fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_KnownUser
    | fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_UnknownUser
    | fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes_User;
export type fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList =
  {
    __typename?: "PaginatedPersonList";
    nodes: Array<fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList_nodes | null> | null;
  };
export type fetchPresenceConfluenceUsersQuery_Query = {
  __typename?: "Query";
  confluenceUsers: fetchPresenceConfluenceUsersQuery_confluenceUsers_PaginatedPersonList | null;
};
export type fetchPresenceConfluenceUsersQueryVariables = Exact<{
  accountIds?: InputMaybe<
    | Array<InputMaybe<Scalars["String"]["input"]>>
    | InputMaybe<Scalars["String"]["input"]>
  >;
}>;
export type fetchPresenceConfluenceUsersQuery =
  fetchPresenceConfluenceUsersQuery_Query;
